(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["article-template-vcbs"]) return;
  try {
    
  // Get the header
  var header = document.querySelector(".ArticleToolbar");
  
  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  $(header).on("scroll",function() {
    if (window.scrollTop > 150 ) {
      header.addClass("sticky");
    } else {
      header.removeClass("sticky");
    }
  }); 
  

  } catch(e) { console.error(e); }
})();

})();
